import { useEffect, useState } from "react";
import { Menu, Phone, X } from "lucide-react";

const LINKS = [
  { href: "#o-mnie", label: "O mnie" },
  { href: "#uslugi", label: "Usługi" },
  { href: "#dla-kogo", label: "Dla kogo" },
  { href: "#dlaczego-ja", label: "Dlaczego ja" },
  { href: "#region", label: "Region" },
  { href: "#kontakt", label: "Kontakt" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const light = scrolled || open;
  const ink = light ? "text-slate-900" : "text-white";
  const inkMuted = light ? "text-slate-600" : "text-white/70";

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        light ? "border-b border-slate-200/80 bg-white/85 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-8 lg:px-16">
        <a href="#start" data-testid="nav-logo-link" className="flex items-center gap-3">
          <img
            src="/assets/logo-mark.png"
            alt="Logo Janusz Błotnicki"
            className="h-11 w-auto rounded-md bg-white p-1 ring-1 ring-slate-900/10"
          />
          <span className={`leading-tight ${ink}`}>
            <span className="block font-serif text-base font-semibold tracking-wide">Janusz Błotnicki</span>
            <span className={`block font-mono text-[10px] uppercase tracking-[0.18em] ${inkMuted}`}>
              Investment &amp; Expansion
            </span>
          </span>
        </a>

        <nav data-testid="main-nav" className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className={`text-sm font-medium transition-colors duration-300 hover:text-[#8C6D46] ${inkMuted}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="tel:+48573569181"
            data-testid="nav-phone-cta"
            className={`flex items-center gap-2 rounded-full border px-5 py-2 text-sm font-semibold transition-colors duration-300 ${
              light
                ? "border-slate-900 bg-slate-900 text-white hover:bg-[#8C6D46] hover:border-[#8C6D46]"
                : "border-white/30 text-white hover:border-[#D8B07C] hover:text-[#D8B07C]"
            }`}
          >
            <Phone size={14} strokeWidth={2.2} />
            +48 573 569 181
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          className={`lg:hidden ${ink}`}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="mobile-nav"
          className="border-t border-slate-200 bg-white/95 px-6 py-6 backdrop-blur-xl lg:hidden"
        >
          <div className="flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-slate-700 transition-colors hover:text-[#8C6D46]"
              >
                {l.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};
